// Standard library imports
import React from 'react';

// Internal Module Imports
import Consumption from './Consumption';
import TabsComponent from '../../../../components/Tabs/Tabs';

const ConsumptionIndex = ({ data, setOpen }) => {
    if (data.market) return <Consumption data={data} setOpen={setOpen} />;

    const tabs = [
        { name: 'aFRR', component: <Consumption data={{ ...data, market: 'aFRR' }} setOpen={setOpen} />, tabId: 1 },
        { name: 'mFRR', component: <Consumption data={{ ...data, market: 'mFRR' }} setOpen={setOpen} />, tabId: 2 },
    ];

    return <TabsComponent tabs={tabs} selectedIndex={0} />;
};

export default ConsumptionIndex;
